import { render } from "./Ws.vue?vue&type=template&id=90aaa42c"
import script from "./Ws.vue?vue&type=script&lang=js"
export * from "./Ws.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__